import React, { useEffect, useState } from 'react'
import { useInitTemplate } from '../../hooks/useInitTemplate';
import Banner from './components/Banner';
import AboutSection from './components/AboutSection';
import ServiceSection from './components/ServiceSection';
import Loader from '../../components/Loader';
import CERTIFIED_14001 from '../../assets/images/14001_CERTIFIED.png'
import CERTIFIED_45001  from '../../assets/images/45001_CERTIFIED.png'
import CERTIFIED_9001  from '../../assets/images/9001_CERTIFIED.png'
import excellence from '../../assets/images/excelllence.png'
import integrity from '../../assets/images/integrity.png'
import precision from '../../assets/images/precision.png'
import trust from '../../assets/images/trust.png'

const Home = () => {
    useInitTemplate();
    const [loader,setLoader]=useState(true);
    useEffect(() => {
      setLoader(false);
    }, []);
    if(loader) return <Loader />
  return (
    <div>
      <div className="page-wrapper">
        <Banner />
        <AboutSection />
        <ServiceSection />
        {/* Brand area start here */}
        <section className="brand-section pt-120">
          <div className="container">
            <div className="outer-box">
              <div className="swiper brand-slider">
                <div className="swiper-wrapper">
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={precision} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={integrity} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={excellence} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={trust} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()} >
                        <img src={precision} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={integrity} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={excellence} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={trust} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={precision} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={integrity} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={excellence} alt="Image" />
                      </a>
                    </div>
                  </div>
                  <div className="swiper-slide">
                    <div className="brand-block">
                      <a href="#" onClick={(e)=>e.preventDefault()}>
                        <img src={trust} alt="Image" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Brand area end here */}
        {/* Certification area start here */}
        <section className="certification-section pt-120 pb-120 bg-light paralax__animation">
          <div className="container">
            <div className="sec-title text-center mb-5">
              <h2 className="title wow splt-txt" data-splitting>
                OUR CERTIFICATIONS
              </h2>

              <p
                className="text wow fadeInUp mx-auto"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
                style={{ maxWidth: "850px" }}
              >
                Pak Arab Inspection Limited Company maintains internationally recognized
                certification standards, demonstrating our commitment to quality
                management, environmental responsibility, occupational health &
                safety, and operational excellence across all inspection and
                technical services.
              </p>
            </div>

            <div className="row g-4">
              <div
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay="00ms"
                data-wow-duration="1500ms"
              >
                <div className="card border-0 shadow-sm text-center h-100 p-4 overlay-anim">
                  <img
                    src={CERTIFIED_9001}
                    alt="ISO 9001"
                    className="img-fluid mx-auto mb-4 animation__arryLeftRight"
                    style={{
                      width: "170px",
                      height: "170px",
                      objectFit: "contain",
                    }}
                  />

                  <h4 className="fw-bold mb-2">ISO 9001:2015 Certified</h4>
                  <p className="text-muted mb-0">Quality Management System</p>
                </div>
              </div>

              <div
                className="col-lg-4 col-md-6 wow fadeInUp"
                data-wow-delay="200ms"
                data-wow-duration="1500ms"
              >
                <div className="card border-0 shadow-sm text-center h-100 p-4 overlay-anim">
                  <img
                    src={CERTIFIED_14001}
                    alt="ISO 14001"
                    className="img-fluid mx-auto mb-4 animation__arryLeftRight"
                    style={{
                      width: "170px",
                      height: "170px",
                      objectFit: "contain",
                    }}
                  />

                  <h4 className="fw-bold mb-2">ISO 14001:2015 Certified</h4>
                  <p className="text-muted mb-0">
                    Environmental Management System
                  </p>
                </div>
              </div>

              <div
                className="col-lg-4 col-md-6 mx-md-auto wow fadeInUp"
                data-wow-delay="400ms"
                data-wow-duration="1500ms"
              >
                <div className="card border-0 shadow-sm text-center h-100 p-4 overlay-anim">
                  <img
                    src={CERTIFIED_45001}
                    alt="ISO 45001"
                    className="img-fluid mx-auto mb-4 animation__arryLeftRight"
                    style={{
                      width: "170px",
                      height: "170px",
                      objectFit: "contain",
                    }}
                  />

                  <h4 className="fw-bold mb-2">ISO 45001:2018 Certified</h4>
                  <p className="text-muted mb-0">
                    Occupational Health & Safety Management System
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Certification area end here */}
      </div>
    </div>
  );
}

export default Home